<app-page-heading [heading]="'Add a Drug Management Plan'" [tabName]="'drug-management-plans'"></app-page-heading>

<div *ngIf="isEdit && editDrugManagementPlan.drugManagementPlanId == null || isSaving" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div class="stepper-container">
  <mat-horizontal-stepper #stepper [linear]="true">
    <mat-step [completed]="generalFormGroup.valid">
      <ng-template matStepLabel>General</ng-template>
      <form [formGroup]="generalFormGroup">
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Management Plan Name</mat-label>
              <input [formControl]="drugManagementPlanNameFormControl" matInput required type="text">
            </mat-form-field>
            <mat-icon #manPlanNameTooltip="matTooltip" [matTooltip]="getInfoTooltip('Management Plan Name')"
                      class="info-icon">help_outline
            </mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <p>
              <label class="column-label">Attach the Drug Management Plan to a <b>policy</b> OR <b>product</b>:</label>
              <br>
              <mat-radio-group (change)="disableGeneralFormField()" [(ngModel)]="chosenPlanApplication"
                               [ngModelOptions]="{standalone: true}" aria-label="Select a policy OR product"
                               class="example-radio-group">
                <mat-radio-button *ngFor="let app of planApplications" [value]="app" class="radio-button">
                  {{app}}
                </mat-radio-button>
              </mat-radio-group>
            </p>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="Start Date"
              [required]="true"
              [formControl]="drugManagementPlanStartDateFormControl"
              [tooltip]="getInfoTooltip('Management Plan Start Date')"
              [maxDate]="drugManagementPlanEndDateFormControl.value"
              [customErrorMessages]="{
                matDatepickerMax: 'The start date must be less than or equal to the end date'
              }"
              (valueChange)="generalStartDateChanged()">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Policy</mat-label>
              <mat-select [formControl]="drugManagementPlanPolicyFormControl" name="policy" required>
                <mat-option *ngFor="let policy of policies" [value]="policy.name">
                  {{policy.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon #manPlanStartPolicyTooltip="matTooltip" [matTooltip]="getInfoTooltip('Management Plan Policy')"
                      class="info-icon">help_outline
            </mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="End Date"
              [formControl]="drugManagementPlanEndDateFormControl"
              [tooltip]="getInfoTooltip('Management Plan End Date')"
              [minDate]="drugManagementPlanStartDateFormControl.value"
              [customErrorMessages]="{
                matDatepickerMin: 'The end date must be greater than or equal to the start date'
              }"
              (valueChange)="generalEndDateChanged()"
              hint="Leave blank to be open dated">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Product</mat-label>
              <mat-select [formControl]="drugManagementPlanProductFormControl" name="product" required>
                <mat-option *ngFor="let product of products" [value]="product.name">
                  {{product.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon #manPlanProductTooltip="matTooltip" [matTooltip]="getInfoTooltip('Management Plan Product')"
                      class="info-icon">help_outline
            </mat-icon>
          </mat-grid-tile>
        </mat-grid-list>
      </form>
      <div class="button-container">
        <button (click)="generalFormGroup.reset()" color="warn" mat-raised-button>Clear</button>
        <button (click)="generalNext()" color="primary" mat-raised-button>Next</button>
      </div>
    </mat-step>
    <mat-step [completed]="refillParametersFormGroup.valid || (isEdit && chosenRefillOption === 'Current')">
      <ng-template matStepLabel>Refill Parameters</ng-template>
      <div [hidden]="!isEdit" class="center">
        <label class="column-label">Continue the current refill parameters, or specify new refill parameters:</label>
      </div>
      <div [hidden]="!isEdit" class="center">
        <mat-radio-group [(ngModel)]="chosenRefillOption" aria-label="Select current or new"
                         class="example-radio-group">
          <mat-radio-button (change)="refillOptionChange($event)" *ngFor="let option of editOptions" [value]="option"
                            class="radio-button">
            {{option}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <form [formGroup]="refillParametersFormGroup">
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Refill Reference Name</mat-label>
              <input (blur)="blurRefillName()" (input)="onInputChangedSearchRefills($event)" [formControl]="refillNameFormControl" [matAutocomplete]="refillAuto"
                     matInput required type="text" placeholder="Search for a refill">
              <mat-autocomplete #refillAuto="matAutocomplete" [panelWidth]="'40vw'">
                <mat-option (onSelectionChange)="refillSelected($event.source.value)" *ngFor="let refill of filteredRefills" [value]="getRefillDisplayString(refill)"
                            class="custom-mat-option">
                  {{getRefillDisplayString(refill)}}
                </mat-option>
              </mat-autocomplete>
              <button (click)="clearRefillName()" *ngIf="refillNameFormControl.value && chosenRefillOption == 'New'" aria-label="Clear"
                      mat-button mat-icon-button matSuffix>
                <mat-icon style="color: grey;">clear</mat-icon>
              </button>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Refill Reference Name')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="Start Date"
              [required]="true"
              [formControl]="refillStartDateFormControl"
              [tooltip]="getInfoTooltip('Refill Start Date')"
              [minDate]="getMinDate(generalStartDate, dmpRefills)"
              [maxDate]="refillEndDateFormControl.value"
              [customErrorMessages]="{
                matDatepickerMin: 'The date must be within the confines of the plan\'s start and end dates, and greater than the latest refill',
                matDatepickerMax: 'The start date must be less than or equal to the end date'
              }">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile>
            <div *ngIf="chosenRefillOption == 'New'" style="text-align: center">
              <p>Manage the refill with the buttons below</p>
              <button (click)="deleteRefill()" *ngIf="selectedRefill != null" color="warn" mat-raised-button
                      [matTooltip]="deleteTooltip">
                Delete
              </button>
              <button (click)="openRefillDialog()" color="primary" mat-raised-button
                      [matTooltip]="addRefillText === 'Add' ? addTooltip : editTooltip">{{addRefillText}}</button>
            </div>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="End Date"
              [formControl]="refillEndDateFormControl"
              [tooltip]="getInfoTooltip('Refill End Date')"
              [minDate]="refillStartDateFormControl.value"
              [maxDate]="generalEndDate"
              [customErrorMessages]="{
                matDatepickerMin: 'The end date must be greater than or equal to the start date',
                matDatepickerMax: 'The date must be within the confines of the plan\'s start and end dates'
              }"
              hint="Leave blank to be open dated">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile>

          </mat-grid-tile>
        </mat-grid-list>
        <div *ngIf="isEdit && dmpRefills.length > (chosenRefillOption == 'Current' ? 1 : 0)" class="center">
          <label class="column-label">Refill parameter history</label>
        </div>
        <div *ngIf="isEdit" class="center">
          <p *ngFor="let refillLink of dmpRefills | slice:(chosenRefillOption == 'Current' ? 1 : 0):dmpRefills.length">
            <b>{{refillLink.startDate | date: dateFormat}}
              - {{chooseDate(refillLink.endDate, refillStartDateFormControl.value) | date: dateFormat}}</b>: {{refillLink.refill.name}}
          </p>
        </div>
        <div class="button-container">
          <button color="primary" mat-raised-button matStepperPrevious>Back</button>
          <button color="warn" mat-raised-button>Clear</button>
          <button (click)="refillNext()" color="primary" mat-raised-button>Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step [completed]="prescriptionLimitsFormGroup.valid  || (isEdit && chosenPrescriptionOption === 'Current')">
      <ng-template matStepLabel>Prescription Limits</ng-template>
      <div [hidden]="!isEdit" class="center">
        <label class="column-label">Continue the current prescription limits, or specify new prescription
          limits:</label>
      </div>
      <div [hidden]="!isEdit" class="center">
        <mat-radio-group [(ngModel)]="chosenPrescriptionOption" aria-label="Select current or new"
                         class="example-radio-group">
          <mat-radio-button (change)="prescriptionOptionChange($event)" *ngFor="let option of editOptions" [value]="option"
                            class="radio-button">
            {{option}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <form [formGroup]="prescriptionLimitsFormGroup">
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Max Days Supply <b>During</b> Policy Period</mat-label>
              <input [formControl]="prescriptionDuringValueFormControl" matInput required type="number" [min]="0">
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Prescription Limit During Value')" class="info-icon">help_outline
            </mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="Start Date"
              [required]="true"
              [formControl]="prescriptionStartDateFormControl"
              [tooltip]="getInfoTooltip('Prescription Limit Start Date')"
              [minDate]="getMinDate(generalStartDate, dmpPrescriptions)"
              [maxDate]="prescriptionEndDateFormControl.value"
              [customErrorMessages]="{
                matDatepickerMin: 'The date must be within the confines of the plan\'s start and end dates, and greater than the latest prescription',
                matDatepickerMax: 'The start date must be less than or equal to the end date'
              }">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Max Days Supply <b>After</b> Policy Period</mat-label>
              <input [formControl]="prescriptionAfterValueFormControl" matInput required type="number" [min]="0">
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Prescription Limit After Value')" class="info-icon">help_outline
            </mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="End Date"
              [formControl]="prescriptionEndDateFormControl"
              [tooltip]="getInfoTooltip('Prescription Limit End Date')"
              [minDate]="prescriptionStartDateFormControl.value"
              [maxDate]="generalEndDate"
              [customErrorMessages]="{
                matDatepickerMin: 'The end date must be greater than or equal to the start date',
                matDatepickerMax: 'The date must be within the confines of the plan\'s start and end dates'
              }"
              hint="Leave blank to be open dated">
            </greydom-date-picker>
          </mat-grid-tile>
        </mat-grid-list>
        <div *ngIf="isEdit && dmpPrescriptions.length > (chosenPrescriptionOption == 'Current' ? 2 : 0)" class="center">
          <label class="column-label">Prescription limit history</label>
        </div>
        <div *ngIf="isEdit" class="center">
          <p
            *ngFor="let prescriptionLink of dmpPrescriptions | slice:(chosenPrescriptionOption == 'Current' ? 2 : 0):dmpPrescriptions.length">
            <b>{{prescriptionLink.startDate | date: dateFormat}}
              - {{chooseDate(prescriptionLink.endDate, prescriptionStartDateFormControl.value) | date: dateFormat}}</b>: {{prescriptionLink.value}} {{prescriptionLink.prescriptionLimitType.name}}
          </p>
        </div>
        <div class="button-container">
          <button color="primary" mat-raised-button matStepperPrevious>Back</button>
          <button color="warn" mat-raised-button>Clear</button>
          <button (click)="prescriptionNext()" color="primary" mat-raised-button>Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step [completed]="therapeuticDuplicationsFormGroup.valid  || (isEdit && chosenTherapeuticOption === 'Current')">
      <ng-template matStepLabel>Therapeutic Duplication Parameters</ng-template>
      <div [hidden]="!isEdit" class="center">
        <label class="column-label">Continue the current therapeutic duplication parameters, or specify new therapeutic
          duplication parameters:</label>
      </div>
      <div [hidden]="!isEdit" class="center">
        <mat-radio-group [(ngModel)]="chosenTherapeuticOption" aria-label="Select current or new"
                         class="example-radio-group">
          <mat-radio-button (change)="therapeuticOptionChange($event)" *ngFor="let option of editOptions" [value]="option"
                            class="radio-button">
            {{option}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <form [formGroup]="therapeuticDuplicationsFormGroup">
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile [rowspan]="4">
            <div>
              <p class="column-label">Set therapeutic duplication rules:</p>
              <mat-checkbox (change)="changeTherapeuticDuplication()"
                            [formControl]="applyTherapeuticDuplicationFormControl">Apply therapeutic duplication rules
              </mat-checkbox>
              <mat-icon [matTooltip]="getInfoTooltip('Therapeutic Duplication Apply Rules')" class="info-icon">help_outline
              </mat-icon>
              <br>
              <mat-checkbox (change)="changeLevelFour()" [formControl]="applyLevelFourFormControl">Apply level four
                therapeutic duplication rules
              </mat-checkbox>
              <mat-icon [matTooltip]="getInfoTooltip('Therapeutic Duplication Apply level Four')" class="info-icon">help_outline
              </mat-icon>
              <br>
              <mat-checkbox [formControl]="applyLevelFourDosageFormControl" class="child-checkbox">Apply level four
                dosage form check
              </mat-checkbox>
              <mat-icon [matTooltip]="getInfoTooltip('Therapeutic Duplication Apply Level Four Dosage')" class="info-icon">help_outline
              </mat-icon>
              <br>
              <mat-slide-toggle [formControl]="applyLevelFourDosageIndicatorFormControl"
                                class="child-checkbox">{{applyLevelFourDosageIndicatorFormControl.value === 1 ? 'REJECT' : 'WARN'}}
                dosage indicator
              </mat-slide-toggle>
              <mat-icon [matTooltip]="getInfoTooltip('Therapeutic Duplication Dosage Indicator')" class="info-icon">help_outline
              </mat-icon>
              <br>
              <mat-checkbox (change)="changeLevelFive()" [formControl]="applyLevelFiveFormControl">Apply level five
                therapeutic duplication rules
              </mat-checkbox>
              <mat-icon [matTooltip]="getInfoTooltip('Therapeutic Duplication Apply Level Five')" class="info-icon">help_outline
              </mat-icon>
              <br>
              <mat-checkbox [formControl]="applyLevelFiveDosageFormControl" class="child-checkbox">Apply level dosage
                form check
              </mat-checkbox>
              <mat-icon [matTooltip]="getInfoTooltip('Therapeutic Duplication Dosage Indicator')" class="info-icon">help_outline
              </mat-icon>
              <br>
              <mat-slide-toggle [formControl]="applyLevelFiveDosageIndicatorFormControl"
                                class="child-checkbox">{{applyLevelFiveDosageIndicatorFormControl.value === 1 ? 'REJECT' : 'WARN'}}
                dosage indicator
              </mat-slide-toggle>
              <mat-icon [matTooltip]="getInfoTooltip('Therapeutic Duplication Apply Rules')" class="info-icon">help_outline
              </mat-icon>
              <br>
            </div>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="Start Date"
              [required]="true"
              [formControl]="therapeuticStartDateFormControl"
              [tooltip]="getInfoTooltip('Therapeutic Duplication Start Date')"
              [minDate]="getMinDate(generalStartDate, dmpTherapeuticDuplications)"
              [maxDate]="therapeuticEndDateFormControl.value"
              [customErrorMessages]="{
                matDatepickerMin: 'The date must be within the confines of the plan\'s start and end dates, and greater than the latest therapeutic duplication',
                matDatepickerMax: 'The start date must be less than or equal to the end date'
              }">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="End Date"
              [formControl]="therapeuticEndDateFormControl"
              [tooltip]="getInfoTooltip('Therapeutic Duplication End Date')"
              [minDate]="therapeuticStartDateFormControl.value"
              [maxDate]="generalEndDate"
              [customErrorMessages]="{
                matDatepickerMin: 'The end date must be greater than or equal to the start date',
                matDatepickerMax: 'The date must be within the confines of the plan\'s start and end dates'
              }"
              hint="Leave blank to be open dated">
            </greydom-date-picker>
          </mat-grid-tile>
        </mat-grid-list>
        <div *ngIf="isEdit && dmpTherapeuticDuplications.length > (chosenTherapeuticOption == 'Current' ? 1 : 0)" class="center">
          <label class="column-label">Therapeutic duplication parameter history</label>
        </div>
        <div *ngIf="isEdit" class="center">
          <p
            *ngFor="let therapeuticLink of dmpTherapeuticDuplications | slice:(chosenTherapeuticOption == 'Current' ? 1 : 0):dmpTherapeuticDuplications.length">
            <b>{{therapeuticLink.startDate | date: dateFormat}}
              - {{chooseDate(therapeuticLink.endDate, therapeuticStartDateFormControl.value) | date: dateFormat}}</b>: {{therapeuticToString(therapeuticLink)}}
          </p>
        </div>
        <div class="button-container">
          <button color="primary" mat-raised-button matStepperPrevious>Back</button>
          <button color="warn" mat-raised-button>Clear</button>
          <button (click)="therapeuticNext()" color="primary" mat-raised-button>Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step [completed]="stepTherapiesFormGroup.valid  || (isEdit && chosenStepTherapyOption === 'Current')">
      <ng-template matStepLabel>Step Therapies</ng-template>
      <div [hidden]="!isEdit" class="center">
        <label class="column-label">Continue the current step therapies, or specify new step therapies:</label>
      </div>
      <div [hidden]="!isEdit" class="center">
        <mat-radio-group [(ngModel)]="chosenStepTherapyOption" aria-label="Select current or new"
                         class="example-radio-group">
          <mat-radio-button (change)="stepTherapyOptionChange($event)" *ngFor="let option of editOptions" [value]="option"
                            class="radio-button">
            {{option}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <form [formGroup]="stepTherapiesFormGroup">
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Select a Step Therapy</mat-label>
              <mat-select [formControl]="stepTherapyFormControl" name="stepTherapy" (selectionChange)="addStepTherapy()">
                <mat-option *ngFor="let stepTherapy of displayedStepTherapies" [value]="stepTherapy.name">
                  {{stepTherapy.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Step Therapy Name')" class="info-icon">help_outline
            </mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="Start Date"
              [required]="true"
              [formControl]="stepTherapyStartDateFormControl"
              [tooltip]="getInfoTooltip('Step Therapy Start Date')"
              [minDate]="getMinDate(generalStartDate, dmpStepTherapies)"
              [maxDate]="stepTherapyEndDateFormControl.value"
              [customErrorMessages]="{
                matDatepickerMin: 'The date must be within the confines of the plan\'s start and end dates, and greater than the latest step therapy',
                matDatepickerMax: 'The start date must be less than or equal to the end date'
              }">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile>
            <p *ngIf="stepTherapies.length > 0" class="column-label">Applied step therapies:</p>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="End Date"
              [formControl]="stepTherapyEndDateFormControl"
              [tooltip]="getInfoTooltip('Step Therapy End Date')"
              [minDate]="stepTherapyStartDateFormControl.value"
              [maxDate]="generalEndDate"
              [customErrorMessages]="{
                matDatepickerMin: 'The end date must be greater than or equal to the start date',
                matDatepickerMax: 'The date must be within the confines of the plan\'s start and end dates'
              }"
              hint="Leave blank to be open dated">
            </greydom-date-picker>
          </mat-grid-tile>
        </mat-grid-list>
        <div>
          <div formArrayName="stepTherapies">
            <div *ngFor="let therapyGrp of stepTherapies.controls; let i=index" class="dmp-form-array">
              <ng-container [formGroup]="therapyGrp">
                <mat-form-field style="width: 16vw; padding-right: 1vw;">
                  <mat-label>Step Therapy {{i + 1}}</mat-label>
                  <input formControlName="stepTherapy" matInput required/>
                  <span *ngIf="chosenStepTherapyOption != 'Current'" matSuffix><a (click)="removeStepTherapy(i)" style="cursor: pointer;"><mat-icon>delete</mat-icon></a></span>
                </mat-form-field>
              </ng-container>
            </div>
          </div>
        </div>
        <div *ngIf="isEdit && displayedStepTherapyLinks().length >= 1" class="center">
          <label class="column-label">Step therapy history</label>
        </div>
        <div *ngIf="isEdit" class="center">
          <p *ngFor="let stepTherapyLink of displayedStepTherapyLinks()">
            <b>{{stepTherapyLink.startDate | date: dateFormat}}
              - {{chooseDate(stepTherapyLink.endDate, stepTherapyStartDateFormControl.value) | date: dateFormat}}</b>: {{stepTherapyLink.name}}
          </p>
        </div>
        <div class="button-container">
          <button color="primary" mat-raised-button matStepperPrevious>Back</button>
          <button color="warn" mat-raised-button>Clear</button>
          <button (click)="stepTherapyNext()" color="primary" mat-raised-button>Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step [completed]="formulariesFormGroup.valid  || (isEdit && chosenFormularyOption === 'Current')">
      <ng-template matStepLabel>Formularies</ng-template>
      <div [hidden]="!isEdit" class="center">
        <label class="column-label">Continue the current formularies, or specify new formularies:</label>
      </div>
      <div [hidden]="!isEdit" class="center">
        <mat-radio-group [(ngModel)]="chosenFormularyOption" aria-label="Select current or new"
                         class="example-radio-group">
          <mat-radio-button (change)="formularyOptionChange($event)" *ngFor="let option of editOptions" [value]="option"
                            class="radio-button">
            {{option}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <form [formGroup]="formulariesFormGroup">
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Select a Formulary</mat-label>
              <input #formularyNameElement [formControl]="formularyFormControl" matInput type="search" [matAutocomplete]="formularyAuto" (input)="onInputChangedSearchFormularies($event)" (blur)="blurFormulary()">
              <mat-autocomplete #formularyAuto="matAutocomplete">
                <mat-option *ngFor="let formulary of filteredFormularies" [value]="getFormularyDisplayString(formulary)">
                  {{getFormularyDisplayString(formulary)}}
                </mat-option>
              </mat-autocomplete>
              <button mat-button mat-icon-button matSuffix  (click)="addFormulary()">
                <mat-icon style="color: grey;">add</mat-icon>
              </button>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Formulary Name')" class="info-icon">help_outline
            </mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="Start Date"
              [required]="true"
              [formControl]="formularyStartDateFormControl"
              [tooltip]="getInfoTooltip('Formulary Start Date')"
              [minDate]="getMinDate(generalStartDate, dmpFormularies)"
              [maxDate]="formularyEndDateFormControl.value"
              [customErrorMessages]="{
                matDatepickerMin: 'The date must be within the confines of the plan\'s start and end dates, and greater than the latest formulary',
                matDatepickerMax: 'The start date must be less than or equal to the end date'
              }">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile>
            <p *ngIf="formularies.length > 0" class="column-label">Applied Formularies:</p>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="End Date"
              [formControl]="formularyEndDateFormControl"
              [tooltip]="getInfoTooltip('Formulary End Date')"
              [minDate]="formularyStartDateFormControl.value"
              [maxDate]="generalEndDate"
              [customErrorMessages]="{
                matDatepickerMin: 'The end date must be greater than or equal to the start date',
                matDatepickerMax: 'The date must be within the confines of the plan\'s start and end dates'
              }"
              hint="Leave blank to be open dated">
            </greydom-date-picker>
          </mat-grid-tile>
        </mat-grid-list>
        <div>
          <div formArrayName="formularies">
            <div *ngFor="let formularyGrp of formularies.controls; let i=index" class="dmp-form-array">
              <ng-container [formGroup]="formularyGrp">
                <mat-form-field  style="width: 16vw; padding-right: 1vw;">
                  <mat-label>Formulary {{i + 1}}</mat-label>
                  <input formControlName="formulary" matInput required/>
                  <span *ngIf="chosenFormularyOption != 'Current'" matSuffix><a (click)="removeFormulary(i)" style="cursor: pointer;"><mat-icon>delete</mat-icon></a></span>
                </mat-form-field>
              </ng-container>
            </div>
          </div>
        </div>
        <div *ngIf="isEdit && displayedFormularyLinks().length >= 1" class="center">
          <label class="column-label">Formulary history</label>
        </div>
        <div *ngIf="isEdit" class="center">
          <p *ngFor="let formularyLink of displayedFormularyLinks()">
            <b>{{formularyLink.startDate | date: dateFormat}}
              - {{chooseDate(formularyLink.endDate, formularyStartDateFormControl.value) | date: dateFormat}}</b>: {{formularyLink.name}}
          </p>
        </div>
        <div class="button-container">
          <button color="primary" mat-raised-button matStepperPrevious>Back</button>
          <button color="warn" mat-raised-button>Clear</button>
          <button color="primary" mat-raised-button (click)="formularyNext()">Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step [completed]="grandfatherFormGroup.valid  || (isEdit && chosenGrandfatherOption === 'Current')">
      <ng-template matStepLabel>Grandfathering</ng-template>
      <div [hidden]="!isEdit" class="center">
        <label class="column-label">Continue the current grandfathering, or specify new grandfathering:</label>
      </div>
      <div [hidden]="!isEdit" class="center">
        <mat-radio-group [(ngModel)]="chosenGrandfatherOption" aria-label="Select current or new"
                         class="example-radio-group">
          <mat-radio-button (change)="grandfatherOptionChange($event)" *ngFor="let option of editOptions" [value]="option"
                            class="radio-button">
            {{option}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <form [formGroup]="grandfatherFormGroup">
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>

            <mat-form-field>
              <mat-label>Grandfather Name</mat-label>
              <input (blur)="blurGrandfatherName()" (input)="onInputChangedSearchGrandfathers($event)" [formControl]="grandfatherNameFormControl" [matAutocomplete]="grandfatherAuto"
                     matInput required type="text" placeholder="Search for a grandfather">
              <mat-autocomplete #grandfatherAuto="matAutocomplete" [panelWidth]="'40vw'">
                <mat-option (onSelectionChange)="grandfatherSelected($event.source.value)" *ngFor="let grandfather of filteredGrandfathers" [value]="getGrandfatherDisplayString(grandfather)"
                            class="custom-mat-option">
                  {{getGrandfatherDisplayString(grandfather)}}
                </mat-option>
              </mat-autocomplete>
              <button (click)="clearGrandfatherName()" *ngIf="grandfatherNameFormControl.value && chosenGrandfatherOption == 'New'" aria-label="Clear"
                      mat-button mat-icon-button matSuffix>
                <mat-icon style="color: grey;">clear</mat-icon>
              </button>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Grandfather Name')" class="info-icon">help_outline</mat-icon>

          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="Start Date"
              [required]="true"
              [formControl]="grandfatherStartDateFormControl"
              [tooltip]="getInfoTooltip('Grandfather Start Date')"
              [minDate]="getMinDate(generalStartDate, dmpGrandfathers)"
              [maxDate]="grandfatherEndDateFormControl.value">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile>
            <div *ngIf="chosenGrandfatherOption == 'New'" style="text-align: center ">
              <p>Manage the grandfather with the buttons below</p>
              <button (click)="deleteGrandfather()" *ngIf="selectedGrandfather != null" color="warn" mat-raised-button
                      [matTooltip]="deleteTooltip">
                Delete
              </button>
              <button (click)="openGrandfatherDialog()" color="primary" mat-raised-button
                      [matTooltip]="addGrandfatherText === 'Add' ? addTooltip : editTooltip">{{addGrandfatherText}}</button>
            </div>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="End Date"
              [formControl]="grandfatherEndDateFormControl"
              [tooltip]="getInfoTooltip('Grandfather End Date')"
              [minDate]="grandfatherStartDateFormControl.value"
              [maxDate]="generalEndDate"
              hint="Leave blank to be open dated">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile>

          </mat-grid-tile>
        </mat-grid-list>
        <div *ngIf="isEdit && dmpGrandfathers.length > (chosenGrandfatherOption == 'Current' ? 1 : 0)" class="center">
          <label class="column-label">Grandfather history</label>
        </div>
        <div *ngIf="isEdit" class="center">
          <p *ngFor="let grandfatherLink of dmpGrandfathers | slice:(chosenGrandfatherOption == 'Current' ? 1 : 0):dmpGrandfathers.length">
            <b>{{grandfatherLink.startDate | date: dateFormat}}
              - {{chooseDate(grandfatherLink.endDate, grandfatherStartDateFormControl.value) | date: dateFormat}}</b>: {{grandfatherLink.grandfather.name}}
          </p>
        </div>
        <div class="button-container">
          <button color="primary" mat-raised-button matStepperPrevious>Back</button>
          <button color="warn" mat-raised-button>Clear</button>
          <button (click)="grandfatherNext()" color="primary" mat-raised-button>Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step [completed]="isEdit">
      <ng-template matStepLabel>Finish</ng-template>
      <mat-grid-list cols="2" rowHeight="80px">

        <mat-grid-tile [colspan]="2">
          <div class="sub-heading-block">
            <h1 class="sub-heading">General</h1>
          </div>
        </mat-grid-tile>

        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Plan Name</p>
            <p class="content">{{drugManagementPlanNameFormControl.value}}</p>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Plan <b>{{chosenPlanApplication}}</b></p>
            <p class="content">{{chosenPlanApplication === 'Policy' ? drugManagementPlanPolicyFormControl.value : drugManagementPlanProductFormControl.value}}</p>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Plan Date Range</p>
            <p class="content">{{drugManagementPlanStartDateFormControl.value | date: dateFormat}} - {{drugManagementPlanEndDateFormControl.value | date: dateFormat}}</p>
          </div>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="2">
          <div class="sub-heading-block">
            <mat-divider></mat-divider>
            <h1 class="sub-heading">Refill Parameters</h1>
          </div>
        </mat-grid-tile>

        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Refill Information</p>
            <a (click)="openDialog('Refill')" class="link">{{selectedRefill != null ? selectedRefill.name : ''}}</a>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Refill Date Range</p>
            <p class="content">{{refillStartDateFormControl.value | date: dateFormat}} - {{refillEndDateFormControl.value | date: dateFormat}}</p>
          </div>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="2">
          <div class="sub-heading-block">
            <mat-divider></mat-divider>
            <h1 class="sub-heading">Prescription Limits</h1>
          </div>
        </mat-grid-tile>

        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Max Days Supply <b>During</b> Policy Period</p>
            <p class="content">{{prescriptionDuringValueFormControl.value}}</p>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Max Days Supply <b>After</b> Policy Period</p>
            <p class="content">{{prescriptionAfterValueFormControl.value}}</p>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Prescription Date Range</p>
            <p class="content">{{prescriptionStartDateFormControl.value | date: dateFormat}} - {{prescriptionEndDateFormControl.value | date: 'dd MMM y'}}</p>
          </div>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="2">
          <div class="sub-heading-block">
            <mat-divider></mat-divider>
            <h1 class="sub-heading">Therapeutic Duplication Parameters</h1>
          </div>
        </mat-grid-tile>

        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Therapeutic Duplication Rules</p>
            <p class="content">{{therapeuticToString(getTherapeuticDuplication())}}</p>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Therapeutic Date Range</p>
            <p class="content">{{therapeuticStartDateFormControl.value | date: dateFormat}} - {{therapeuticEndDateFormControl.value | date: dateFormat}}</p>
          </div>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="2">
          <div class="sub-heading-block">
            <mat-divider></mat-divider>
            <h1 class="sub-heading">Step Therapies</h1>
          </div>
        </mat-grid-tile>

        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Step Therapies</p>
            <a (click)="openDialog('Step Therapy(ies)')" class="link">View All</a>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Step Therapy Date Range</p>
            <p class="content">{{stepTherapyStartDateFormControl.value | date: dateFormat}} - {{stepTherapyEndDateFormControl.value | date: dateFormat}}</p>
          </div>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="2">
          <div class="sub-heading-block">
            <mat-divider></mat-divider>
            <h1 class="sub-heading">Formularies</h1>
          </div>
        </mat-grid-tile>

          <mat-grid-tile>
            <div class="display-field">
              <p class="label">Formularies</p>
              <a (click)="openDialog('Formulary(ies)')" class="link">View All</a>
            </div>
          </mat-grid-tile>
        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Formulary Date Range</p>
            <p class="content">{{formularyStartDateFormControl.value | date: dateFormat}} - {{formularyEndDateFormControl.value | date: dateFormat}}</p>
          </div>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="2">
          <div class="sub-heading-block">
            <mat-divider></mat-divider>
            <h1 class="sub-heading">Grandfathering</h1>
          </div>
        </mat-grid-tile>

        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Grandfather Information</p>
            <a (click)="openDialog('Grandfather')" class="link">{{selectedGrandfather != null ? selectedGrandfather.name : ''}}</a>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Grandfather Date Range</p>
            <p class="content">{{grandfatherStartDateFormControl.value | date: dateFormat}} - {{grandfatherEndDateFormControl.value | date: dateFormat}}</p>
          </div>
        </mat-grid-tile>

      </mat-grid-list>
      <div class="button-container">
        <button mat-raised-button matStepperPrevious color="primary">Previous</button>
        <button mat-raised-button matStepperPrevious color="warn" (click)="stepper.reset()">Clear</button>
        <button mat-raised-button color="primary" (click)="finish()">Finish</button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>
